"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkillTagList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const SkillTagRatingSliderField_1 = require("@src/components/modules/forms/SkillTagRatingSliderField/SkillTagRatingSliderField");
const react_1 = __importDefault(require("react"));
const SkillTagList = ({ tags }) => {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: tags.map(({ id, name, value }, index) => ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(SkillTagRatingSliderField_1.SkillTagRatingSliderField, { name: index, label: name, tagId: id, value: { id, value } }) }, id))) }));
};
exports.SkillTagList = SkillTagList;
